import { colors } from './colors.theme'

export const popoverTheme = {
  paper: {
    backgroundColor: colors.paper2,
    backgroundImage: 'none',
  },
}
